<template>
    <div class="summary" :class="isDesktop ? 'isDesktop' : 'isMobile'">
        <Mub class="options" v-for="tab in results" :key="tab.type" :raw-data="tab.mubData">
            <div class="line-option">
                <span class="title">{{ tab.title }}<span class="total">{{ tab.total }}</span></span>
                <a class="see-more" :href="tab.url">{{ txtSeeMore }} <i class="prz-chevron-right"></i></a>
            </div>
            <div class="items">
                <a class="item" v-for="(row, index) in tab.items" :key="tab.type + '-' + index" :href="row.url" @click.prevent="onItemClick(row)">
                    <img :src="row.image">
                    <span>{{ row.name }}</span>
                </a>
            </div>
        </Mub>
    </div>
</template>
<script>

import Mub from '@/components/Mub.vue';

export default {
    name: "Summary",
    components:{
        Mub,
    },
    props: {
        isDesktop:{
            type: Boolean,
            default: false
        },
        results:{
            type: Array,
            default: undefined
        },
        txtSeeMore:{
            type: String,
            default: undefined
        },
    },
    // data() {
    //     return {};
    // },
    // computed: {
    // },
    methods: {
        onItemClick(item){
            if(!this.isDesktop){
                let historyUrl = null;
                this.results.forEach(tab => {
                    if(tab.type === item.type){
                        historyUrl = tab.url;
                    }
                });
                if(historyUrl && window.location.port !== '8080'){
                    window.history.pushState({}, "", historyUrl);
                }
            }
            window.location.href = item.url;
        }
    },
};
</script>
<style lang="scss">
    @import "./Styles/summary.scss";
</style>
